<div class="secondary-navigation" #parentRef>
  <nav id="sub-nav" class="navbar p-0" #navBar>
    <ul class="nav m-0" [class.menu-open]="menuOpen">
      <li class="nav-item mobile-title" (click)="menuOpen = !menuOpen">
        <a class="nav-link">{{ "MENU.PAGE_NAVIGATION" | translate}}</a>
      </li>
      <li class="nav-item" *ngFor="let item of subMenuItems">
        <a class="nav-link" [class.active]="item.active" (click)="scrollToSection(item.sectionId); item.active = true">
          {{item.text}}
          <ng-container *ngIf="item.count || item.count === 0">({{item.count}})</ng-container>
        </a>
      </li>
    </ul>
    <ng-content></ng-content>
  </nav>
</div>
